<template>
    <div id="hayrat-component">
        <div class="hc-video">
            <video controls @play="goFullScreen($event)">
                <source src="@/assets/videos/hayrat_bildirim4_rev_LOW.mp4" type="video/mp4">
            </video>
        </div>
        <div class="hc-text">
            <h3>Yarının suyunu kurtarmak senin elinde!</h3>
            <p>Ne kadar su harcadığını görmek ve <br>
                tasarrufa başlamak için su ayak izini hesapla!  </p>
        </div>
        <div class="hc-button">
            <div class="start-water-print story-button-container" @click="waterPrintStart()">
                <ButtonBlueBackground class="water-print" :text="`Su ayak İzİnİ hesapla`" :to="''"
                                      :button-class="`grey-button`"/>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from "../main";
    import ButtonBlueBackground from "../components/ButtonBlueBackground";

    export default {
        name: "Hayrats",
        mounted() {
            EventBus.$emit('menu-status', false);
            this.$store.commit('navigationStatus', 'subPage');
        },
        methods: {
            goFullScreen(target) {
                if (target.target.requestFullscreen) {
                    target.target.requestFullscreen();
                } else if (target.target.msRequestFullscreen) {
                    target.target.msRequestFullscreen();
                } else if (target.target.mozRequestFullScreen) {
                    target.target.mozRequestFullScreen();
                } else if (target.target.webkitRequestFullscreen) {
                    target.target.webkitRequestFullscreen();
                }
            },
            waterPrintStart() {
                EventBus.$emit('water-print-status');
                dataLayer.push({ event: "promiseCalculate_startPromiseQuiz", page: window.location.pathname == '/' ? 'homepage' : window.location.pathname.replace('/','') })
            }
        },
        components: {ButtonBlueBackground}
    }
</script>

<style lang="scss">
    #hayrat-component {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        width: 100%;

        .hc {
            &-video {
                width: 732px;
                height: 412px;
                margin-top: 96px;
                background-color: white;
                padding: 5px 5px;
                border-radius: 3px;
                & > video {
                    width: 100%;
                    height: 100%;
                    position: relative;
                    z-index: initial;
                    left: initial;
                    transform: initial;
                    top: initial;
                    outline: none;
                }
            }

            &-text {
                margin-top: 48px;
                h3 {
                    text-align: center;
                    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.22);
                    font-family: Quicksand, sans-serif, Tahoma;
                    font-size: 23px;
                    font-weight: bold;
                }
                p {
                    text-align: center;
                    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.22);
                    font-family: Quicksand, sans-serif, Tahoma;
                    font-size: 15px;
                    font-weight: bold;
                }
            }

            &-button {
                margin-top: 29px;
                .story-button-container {
                    height: auto;
                    width: auto;

                    &.start-water-print {
                        margin: 0 15px 0 0;
                    }
                }
            }
        }

        @media only screen and (max-device-width: 768px) {
            height: auto;
            justify-content: initial;

            .hc {
                &-video {
                    width: 100%;
                    height: calc((100vw / 16) * 9);
                }

                &-text {
                    h3 {
                        font-size: 43px;
                    }
                    p {
                        font-size: 26px;
                    }
                }

                &-button {
                    .story-button-container {
                        .grey-button {
                            width: auto;
                            min-width: 220px;

                            @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                                min-width: 622px !important;
                                max-height: 140px;
                                min-height: 140px;
                                margin: 40px 0px;
                                justify-content: flex-start;
                                padding: 0px 50px;
                                box-sizing: border-box;
                            }

                            & > p {
                                @media only screen and (min-device-width: 320px) and (max-device-width: 768px) {
                                    font-size: 35px;
                                    margin-left: 20px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
